import { useRouter } from 'next/router'

const useTeaserMetaTitle = () => {
    const { asPath } = useRouter()
    return asPath?.startsWith('/news/sportwetten/') || asPath?.startsWith('/news/online-casino/')
}

export default useTeaserMetaTitle
